function index() {
  return import(/* webpackChunkName: "page-index" */ '@/pages/index.vue')
}
function carte_e_servizi() {
  return import(
    /* webpackChunkName: "page-carte-e-servizi" */ '@/pages/carte-e-servizi.vue'
  )
}
function carte_e_servizi_carte() {
  return import(
    /* webpackChunkName: "page-carte-e-servizi-carte" */ '@/pages/carte-e-servizi/carte.vue'
  )
}
function carte_e_servizi_carte_creditclassic() {
  return import(
    /* webpackChunkName: "page-carte-e-servizi-carte-creditclassic" */ '@/pages/carte-e-servizi/carte/creditclassic.vue'
  )
}
function carte_e_servizi_carte_creditprestige() {
  return import(
    /* webpackChunkName: "page-carte-e-servizi-carte-creditprestige" */ '@/pages/carte-e-servizi/carte/creditprestige.vue'
  )
}
function carte_e_servizi_carte_internazionale() {
  return import(
    /* webpackChunkName: "page-carte-e-servizi-carte-internazionale" */ '@/pages/carte-e-servizi/carte/internazionale.vue'
  )
}
function carte_e_servizi_carte_panoramica() {
  return import(
    /* webpackChunkName: "page-carte-e-servizi-carte-panoramica" */ '@/pages/carte-e-servizi/carte/panoramica.vue'
  )
}
function carte_e_servizi_carte_prepagata() {
  return import(
    /* webpackChunkName: "page-carte-e-servizi-carte-prepagata" */ '@/pages/carte-e-servizi/carte/prepagata.vue'
  )
}
function carte_e_servizi_internetBanking() {
  return import(
    /* webpackChunkName: "page-carte-e-servizi-internetBanking" */ '@/pages/carte-e-servizi/internetBanking.vue'
  )
}
function carte_e_servizi_tecnologia() {
  return import(
    /* webpackChunkName: "page-carte-e-servizi-tecnologia" */ '@/pages/carte-e-servizi/tecnologia.vue'
  )
}
function carte_e_servizi_tecnologia_applePay() {
  return import(
    /* webpackChunkName: "page-carte-e-servizi-tecnologia-applePay" */ '@/pages/carte-e-servizi/tecnologia/applePay.vue'
  )
}
function carte_e_servizi_tecnologia_bancomatPay() {
  return import(
    /* webpackChunkName: "page-carte-e-servizi-tecnologia-bancomatPay" */ '@/pages/carte-e-servizi/tecnologia/bancomatPay.vue'
  )
}
function carte_e_servizi_tecnologia_bancomatPay_dettagli() {
  return import(
    /* webpackChunkName: "page-carte-e-servizi-tecnologia-bancomatPay-dettagli" */ '@/pages/carte-e-servizi/tecnologia/bancomatPay/dettagli.vue'
  )
}
function carte_e_servizi_tecnologia_digitalPayments() {
  return import(
    /* webpackChunkName: "page-carte-e-servizi-tecnologia-digitalPayments" */ '@/pages/carte-e-servizi/tecnologia/digitalPayments.vue'
  )
}
function carte_e_servizi_tecnologia_mobilePayments() {
  return import(
    /* webpackChunkName: "page-carte-e-servizi-tecnologia-mobilePayments" */ '@/pages/carte-e-servizi/tecnologia/mobilePayments.vue'
  )
}
function carte_e_servizi_tecnologia_plick() {
  return import(
    /* webpackChunkName: "page-carte-e-servizi-tecnologia-plick" */ '@/pages/carte-e-servizi/tecnologia/plick.vue'
  )
}
function footer() {
  return import(/* webpackChunkName: "page-footer" */ '@/pages/footer.vue')
}
function footer_numeriUtili() {
  return import(
    /* webpackChunkName: "page-footer-numeriUtili" */ '@/pages/footer/numeriUtili.vue'
  )
}
function footer_privacy() {
  return import(
    /* webpackChunkName: "page-footer-privacy" */ '@/pages/footer/privacy.vue'
  )
}
function footer_sicurezza() {
  return import(
    /* webpackChunkName: "page-footer-sicurezza" */ '@/pages/footer/sicurezza.vue'
  )
}
function footer_trasparenza() {
  return import(
    /* webpackChunkName: "page-footer-trasparenza" */ '@/pages/footer/trasparenza.vue'
  )
}
function help() {
  return import(/* webpackChunkName: "page-help" */ '@/pages/help.vue')
}
function insiemeperlambiente() {
  return import(
    /* webpackChunkName: "page-insiemeperlambiente" */ '@/pages/insiemeperlambiente.vue'
  )
}
function insiemeperlambiente_ilnostroimpegno() {
  return import(
    /* webpackChunkName: "page-insiemeperlambiente-ilnostroimpegno" */ '@/pages/insiemeperlambiente/ilnostroimpegno.vue'
  )
}
function insiemeperlambiente_mediterraneo() {
  return import(
    /* webpackChunkName: "page-insiemeperlambiente-mediterraneo" */ '@/pages/insiemeperlambiente/mediterraneo.vue'
  )
}
function insiemeperlambiente_plasticFreeVideo() {
  return import(
    /* webpackChunkName: "page-insiemeperlambiente-plasticFreeVideo" */ '@/pages/insiemeperlambiente/plasticFreeVideo.vue'
  )
}
function partner() {
  return import(/* webpackChunkName: "page-partner" */ '@/pages/partner.vue')
}
function quanto() {
  return import(/* webpackChunkName: "page-quanto" */ '@/pages/quanto.vue')
}
function quanto_calcolatore() {
  return import(
    /* webpackChunkName: "page-quanto-calcolatore" */ '@/pages/quanto/calcolatore.vue'
  )
}
function quanto_manifesto() {
  return import(
    /* webpackChunkName: "page-quanto-manifesto" */ '@/pages/quanto/manifesto.vue'
  )
}
function quanto_pacchetti() {
  return import(
    /* webpackChunkName: "page-quanto-pacchetti" */ '@/pages/quanto/pacchetti.vue'
  )
}
function quanto_pacchetti_confrontaConti__packageId() {
  return import(
    /* webpackChunkName: "page-quanto-pacchetti-confrontaConti-packageId" */ '@/pages/quanto/pacchetti/confrontaConti/_packageId.vue'
  )
}
function quanto_vincoli() {
  return import(
    /* webpackChunkName: "page-quanto-vincoli" */ '@/pages/quanto/vincoli.vue'
  )
}
function stories() {
  return import(/* webpackChunkName: "page-stories" */ '@/pages/stories.vue')
}
function tuttorial() {
  return import(
    /* webpackChunkName: "page-tuttorial" */ '@/pages/tuttorial.vue'
  )
}

export default [
  {
    name: 'home',
    path: '',
    component: index,
    meta: {
      label: ' ',
      order: 0,
    },
  },
  {
    name: 'Carte e Servizi',
    path: 'carte-e-servizi',
    component: carte_e_servizi,
    redirect: { name: 'Carte' },
    children: [
      {
        name: 'Carte',
        path: 'carte',
        component: carte_e_servizi_carte,
        meta: {
          order: 5,
          label: 'Carte',
        },
        redirect: { name: 'Panoramica Carte' },
        children: [
          {
            name: 'Carta di credito Classic',
            path: 'creditclassic',
            component: carte_e_servizi_carte_creditclassic,
            meta: {
              tabOrder: 4,
            },
          },
          {
            name: 'Carta di credito Prestige',
            path: 'creditprestige',
            component: carte_e_servizi_carte_creditprestige,
            meta: {
              tabOrder: 5,
            },
          },
          {
            name: 'Carta di debito',
            path: 'internazionale',
            component: carte_e_servizi_carte_internazionale,
            meta: {
              tabOrder: 2,
            },
          },
          {
            name: 'Panoramica Carte',
            path: 'panoramica',
            component: carte_e_servizi_carte_panoramica,
            meta: {
              tabOrder: 1,
            },
          },
          {
            name: 'Carta prepagata',
            path: 'prepagata',
            component: carte_e_servizi_carte_prepagata,
            meta: {
              tabOrder: 3,
            },
          },
        ],
      },
      {
        name: 'Internet Banking',
        path: 'internetBanking',
        component: carte_e_servizi_internetBanking,
        meta: {
          order: 6,
          label: 'Internet Banking',
        },
      },
      {
        name: 'Tecnologia',
        path: 'tecnologia',
        component: carte_e_servizi_tecnologia,
        meta: {
          order: 7,
          label: 'Servizi di Nuova Generazione',
        },
        redirect: { name: 'Pagamenti digitali' },
        children: [
          {
            name: 'Apple Pay',
            path: 'applePay',
            component: carte_e_servizi_tecnologia_applePay,
            meta: {
              tabOrder: 2,
            },
          },
          {
            name: 'Bancomat Pay',
            path: 'bancomatPay',
            component: carte_e_servizi_tecnologia_bancomatPay,
            meta: {
              tabOrder: 4,
            },
            children: [
              {
                name: 'Info Bancomat Pay',
                path: 'dettagli',
                component: carte_e_servizi_tecnologia_bancomatPay_dettagli,
                meta: {},
              },
            ],
          },
          {
            name: 'Pagamenti digitali',
            path: 'digitalPayments',
            component: carte_e_servizi_tecnologia_digitalPayments,
            meta: {
              tabOrder: 1,
            },
          },
          {
            name: 'Mobile Payments',
            path: 'mobilePayments',
            component: carte_e_servizi_tecnologia_mobilePayments,
            meta: {
              tabOrder: 3,
            },
          },
          {
            name: 'Plick',
            path: 'plick',
            component: carte_e_servizi_tecnologia_plick,
            meta: {
              tabOrder: 5,
            },
          },
        ],
      },
    ],
  },
  {
    name: 'footer',
    path: 'footer',
    component: footer,
    meta: {
      order: 13,
      label: 'Trasparenza e Contatti',
      hideMenu: {
        inline: true,
      },
    },
    children: [
      {
        name: 'Numeri utili',
        path: 'numeriUtili',
        component: footer_numeriUtili,
        meta: {},
      },
      {
        name: 'Privacy',
        path: 'privacy',
        component: footer_privacy,
        meta: {},
      },
      {
        name: 'Sicurezza',
        path: 'sicurezza',
        component: footer_sicurezza,
        meta: {},
      },
      {
        name: 'Trasparenza',
        path: 'trasparenza',
        component: footer_trasparenza,
        meta: {},
      },
    ],
  },
  {
    name: 'Help',
    path: 'help',
    component: help,
    meta: {
      order: 11,
      label: 'Help',
    },
  },
  {
    name: "Insieme per l'ambiente",
    path: 'insiemeperlambiente',
    component: insiemeperlambiente,
    meta: {
      order: 9,
      label: "Insieme per l'ambiente",
      directLink: true,
      hideMenu: {
        inline: true,
      },
    },
    redirect: { name: 'Mediterraneo a rischio' },
    children: [
      {
        name: 'Il nostro impegno',
        path: 'ilnostroimpegno',
        component: insiemeperlambiente_ilnostroimpegno,
        meta: {
          tabOrder: 3,
        },
      },
      {
        name: 'Mediterraneo a rischio',
        path: 'mediterraneo',
        component: insiemeperlambiente_mediterraneo,
        meta: {
          tabOrder: 1,
        },
      },
      {
        name: 'Plastic Free',
        path: 'plasticFreeVideo',
        component: insiemeperlambiente_plasticFreeVideo,
        meta: {
          tabOrder: 2,
        },
      },
    ],
  },
  {
    name: 'partner',
    path: 'partner',
    component: partner,
    meta: {
      order: 12,
      label: 'I nostri Partner',
      hideMenu: {
        inline: true,
        main: true,
      },
    },
  },
  {
    name: 'Quanto sei Controcorrente?',
    path: 'quanto',
    component: quanto,
    meta: {
      flatten: true,
    },
    redirect: { name: 'Quanto controcorrente sei?' },
    children: [
      {
        name: 'Quanto controcorrente sei?',
        path: 'calcolatore',
        component: quanto_calcolatore,
        meta: {
          order: 3,
          label: 'Quanto sei Controcorrente?',
        },
      },
      {
        name: 'manifesto',
        path: 'manifesto',
        component: quanto_manifesto,
        meta: {
          order: 1,
          label: 'Scopri perché ControCorrente',
          hideAsChild: {
            inline: true,
            main: true,
          },
        },
      },
      {
        name: 'perchè',
        path: 'pacchetti',
        component: quanto_pacchetti,
        meta: {
          order: 2,
          label: 'Scopri i nostri Pacchetti',
        },
        children: [
          {
            name: 'quanto-pacchetti-confrontaConti-packageId',
            path: 'confrontaConti/:packageId?',
            component: quanto_pacchetti_confrontaConti__packageId,
          },
        ],
      },
      {
        name: 'Vincoli',
        path: 'vincoli',
        component: quanto_vincoli,
        meta: {
          order: 4,
          label: 'Time Deposit',
        },
      },
    ],
  },
  {
    name: 'Storie Controcorrente',
    path: 'stories',
    component: stories,
    meta: {
      order: 10,
      label: 'Storie ControCorrente',
      hideMenu: {
        inline: true,
        main: true,
      },
      disabledRoute: true,
    },
  },
  {
    name: 'Tuttorial',
    path: 'tuttorial',
    component: tuttorial,
    meta: {
      order: 8,
      label: 'Tuttorial',
      hideMenu: {
        inline: true,
      },
    },
  },
]
